import $ from 'jquery';

$(document).ready(function(){

    var loyaltywelcomemodalIsOpen = $('#loyalty-invitation-modal').length > 0;
    if(loyaltywelcomemodalIsOpen){
        triggerLoyaltyWelcomePopup();
        $('#loyalty-invitation-terms').prop('checked', true);
    }

    $('#loyalty-invitation-terms').click(function(){
        if (!$('#loyalty-invitation-terms').is(':checked')) {
            markErrorLoyaltyOptIn();
        } else {
            unMarkErrorLoyaltyOptIn();
        }
    });

    $('#loyalty_join_button').click(function(){
        loyaltyoptIn();
    });
});
function triggerLoyaltyWelcomePopup() {
    $.modal({
        open: "loyalty-invitation-modal",
        triggerOpen: true
    });

}

function closeInvitationPopup() {
    $.modal.close();
}


function loyaltyoptIn(){
    if (!$('#loyalty-invitation-terms').is(':checked')) {
        return;
    }
    var email = $('#loyalty-invitation-email').val();

    var data = $.param({
        cID:  $('#loyalty-invitation-cid').val(),
        loyaltyUserStatusId : $('#loyalty-invitation-user-id').val()
    });
    $.ajax({
        url: '/content/loyalty-club/internal-opt-in',
        data: data,
        type: 'POST',
        dataType: 'json',
        success: function(rtn){
            if (rtn.success){
                closeInvitationPopup();
            } else {
                var errorClasses = 'is-error';
                $('#loyalty-invitation-email-field').addClass(errorClasses);
                $('#loyalty-invitation-email').value(email);
            }
        }
    });
}

function markErrorLoyaltyOptIn(){
    $('#loyalty-invitation-terms').addClass('is-error');
    $('#loyalty-invitation-terms-label').addClass('link--error u-color--error');
    $('#loyalty-invitation-opt-in-error').slideDown();
}

function unMarkErrorLoyaltyOptIn(){
    $('#loyalty-invitation-terms').removeClass('is-error');
    $('#loyalty-invitation-terms-label').removeClass('link--error u-color--error')
    $('#loyalty-invitation-opt-in-error').slideUp();
}


// WEBPACK FOOTER //
// ./src/scripts/modules/loyalty.js